var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMfaWarningBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 187,
  height: 146,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#mfa_warning_blue_svg__clip0_800_51234)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M187 56.464c0 31.184-25.335 56.464-56.586 56.464-31.252 0-56.587-25.28-56.587-56.464C73.827 25.28 99.171 0 130.423 0c31.251 0 56.586 25.28 56.586 56.464H187z",
  fill: "#AFDBF9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.143 45.265H7.227v-4.642c0-3.325 2.723-6.05 6.064-6.05h111.797c3.332 0 6.064 2.716 6.064 6.05v4.642h-.009zM0 107.559h138.065v4.641c0 3.325-2.723 6.051-6.064 6.051H6.064C2.732 118.251 0 115.534 0 112.2v-4.641z",
  fill: "#C2C6CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.143 45.264H7.227v62.303h123.916V45.264z",
  fill: "#7E8084"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.993 58.592h-7.992c-.806 0-1.459.651-1.459 1.455v14.431c0 .804.653 1.456 1.459 1.456h7.992c.806 0 1.459-.652 1.459-1.456V60.047c0-.804-.653-1.455-1.459-1.455zM65.788 58.592h-7.993c-.805 0-1.458.651-1.458 1.455v14.431c0 .804.653 1.456 1.458 1.456h7.993c.806 0 1.459-.652 1.459-1.456V60.047c0-.804-.653-1.455-1.459-1.455zM80.574 58.592h-7.993c-.805 0-1.458.651-1.458 1.455v14.431c0 .804.653 1.456 1.458 1.456h7.993c.805 0 1.458-.652 1.458-1.456V60.047c0-.804-.653-1.455-1.458-1.455zM95.369 58.592h-7.993c-.805 0-1.458.651-1.458 1.455v14.431c0 .804.653 1.456 1.458 1.456h7.993c.805 0 1.458-.652 1.458-1.456V60.047c0-.804-.653-1.455-1.458-1.455z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.39 98.587l-7.069-7.054 2.52-2.524 4.55 4.54 9.008-8.979 2.52 2.515L68.39 98.587z",
  fill: "#3DE896"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.519 76.053h-28.316a5.532 5.532 0 00-5.538 5.526v58.582a5.532 5.532 0 005.538 5.526h28.316a5.532 5.532 0 005.538-5.526V81.579a5.532 5.532 0 00-5.538-5.526z",
  fill: "#6E6F72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.057 85.825h-39.392v-4.237c0-3.039 2.492-5.525 5.538-5.525h28.316c3.046 0 5.538 2.486 5.538 5.525v4.237zM112.665 134.396h39.392v6.079c0 3.039-2.492 5.526-5.538 5.526h-28.316c-3.046 0-5.538-2.487-5.538-5.526v-6.079z",
  fill: "#C2C6CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.13 142.923a2.885 2.885 0 002.889-2.882 2.886 2.886 0 00-2.889-2.883 2.887 2.887 0 00-2.889 2.883 2.886 2.886 0 002.889 2.882z",
  fill: "#7E8084"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.409 100.394v8.271a17.098 17.098 0 01-11.279 16.071 17.098 17.098 0 01-11.278-16.071v-8.271c4.882 1.704 10.134-3.647 11.278-4.917 1.154 1.27 6.406 6.621 11.288 4.917h-.009z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.365 102.448v6.06a16.236 16.236 0 009.756 14.883 16.22 16.22 0 009.756-14.883v-6.06c-3.886-.221-7.412-2.634-9.756-4.706-2.344 2.072-5.87 4.476-9.756 4.706z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.617 116.107l-5.584-5.582 1.993-1.989 3.591 3.592 7.125-7.101 1.993 1.99-9.118 9.09z",
  fill: "#3DC989"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mfa_warning_blue_svg__clip0_800_51234"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h187v146H0z"
})))));
export default SvgMfaWarningBlue;